import CryptoJS from "crypto-js";
import axios from "axios";
import { nanoid } from "nanoid";

const SECRET_KEY = process.env.REACT_APP_NEXTAUTH_SECRET;
const JWT_SECRET = "XH6bp/TkLvnUkQiPDEZNyHc0CV+VV5RL/n+HdVHoHN0=sh";
const apiUrl = process.env.REACT_APP_API_URL;
const base64Encode = (data) => {
  return btoa(unescape(encodeURIComponent(JSON.stringify(data))));
};

// export const generateToken = () => {
//   const header = { alg: "HS256", typ: "JWT" };

//   var user = JSON.parse(localStorage.getItem("c10sjuex"));

//   // const lifetime = 60 * 60 * 24 * 365;
//   // const exp = Math.floor(Date.now() / 1000) + lifetime;

//   const payload = {
//     userId: user?.id,
//     exp: Math.floor(Date.now() / 1000) + 90,
//   };

//   const encodedHeader = base64Encode(header);
//   const encodedPayload = base64Encode(payload);
//   const signature = CryptoJS.HmacSHA256(
//     `${encodedHeader}.${encodedPayload}`,
//     "XH6bp/TkLvnUkQiPDEZNyHc0CV+VV5RL/n+HdVHoHN0=sh"
//   ).toString(CryptoJS.enc.Base64);

//   const jwtToken = `${encodedHeader}.${encodedPayload}.${signature}`;
//   console.log(jwtToken);
//   return jwtToken;
// };

export const CreatePlayload = (payloads) => {
  const header = { alg: "HS256", typ: "JWT" };

  // const lifetime = 60 * 60 * 24 * 365;
  // const exp = Math.floor(Date.now() / 1000) + lifetime;

  const payload = {
    ...payloads,
    exp: Math.floor(Date.now() / 1000) + 160,
  };

  const encodedHeader = base64Encode(header);
  const encodedPayload = base64Encode(payload);

  const signature = CryptoJS.HmacSHA256(
    `${encodedHeader}.${encodedPayload}`,
    JWT_SECRET,
  ).toString(CryptoJS.enc.Base64);

  const jwtToken = `${encodedHeader}.${encodedPayload}.${signature}`;
  return { token: jwtToken };
};

const base64UrlEncode = (str) => {
  return btoa(unescape(encodeURIComponent(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

// const GEtUserData = (payload) => {
//   const getToken = DecodeToken(payload);
//   const user = DecodeToken(getToken?.token);
//   return user;
// };

export const generateToken = async () => {
  const header = { alg: "HS256", typ: "JWT" };

  const user = JSON.parse(localStorage.getItem("c10sjuex"));

  if (!user) {
    console.error("User not logged in!");
    return;
  }

  // const expirationTime = 60 * 60;

  const payloads = {
    userId: user?.id,
    exp: Math.floor(Date.now() / 1000) + 160,
  };

  const payload = {
    payload: payloads,
  };

  const encodedHeader = base64UrlEncode(JSON.stringify(header));
  const encodedPayload = base64UrlEncode(JSON.stringify(payload));

  const dataToSign = `${encodedHeader}.${encodedPayload}`;

  const secretKey = SECRET_KEY;

  const encoder = new TextEncoder();
  const keyData = encoder.encode(secretKey);

  const data = encoder.encode(dataToSign);

  const key = await window.crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: { name: "SHA-256" } },
    false,
    ["sign"],
  );

  const signatureBuffer = await window.crypto.subtle.sign("HMAC", key, data);

  const signatureArray = new Uint8Array(signatureBuffer);
  const signatureBase64 = btoa(String.fromCharCode.apply(null, signatureArray))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

  const jwtToken = `${encodedHeader}.${encodedPayload}.${signatureBase64}`;

  return jwtToken;
};

const base64UrlDecode = (str) => {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  return decodeURIComponent(escape(atob(str)));
};

export const DecodeToken = (token) => {
  try {
    const [encodedHeader, encodedPayload, signature] = token?.split(".");

    const decodedHeader = JSON.parse(base64UrlDecode(encodedHeader));
    const decodedPayload = JSON.parse(base64UrlDecode(encodedPayload));

    return decodedPayload;
  } catch (error) {
    return null;
  }
};

export const DecodeTokenAuth = (token) => {
  try {
    if (!token || typeof token !== "string") return null;

    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const [encodedHeader, encodedPayload, signature] = parts;

    if (!encodedHeader || !encodedPayload || !signature) return null;

    const decodedHeader = JSON.parse(base64UrlDecode(encodedHeader));
    const decodedPayload = JSON.parse(base64UrlDecode(encodedPayload));

    if (decodedPayload.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedPayload.exp < currentTime) {
        console.warn("Token has expired");
        return null;
      }
    }

    return decodedPayload;
  } catch (error) {
    return null;
  }
};

export const GETUser = async (user, endpoints) => {
  const { token } = await CreatePlayload(user);
  const latestToken = nanoid();

  const headers = {
    Authorization: `Bearer ${token}`,
    "xgf-token": latestToken,
  };

  if (user) {
    return axios
      .get(`${apiUrl}/private/${endpoints}`, { headers })
      .then((res) => res)
      .catch((err) => console.error(err));
  }
};
